// Generated by purs version 0.15.15
import * as Affjax from "../Affjax/index.js";
import * as Affjax_RequestBody from "../Affjax.RequestBody/index.js";
import * as Affjax_RequestHeader from "../Affjax.RequestHeader/index.js";
import * as Affjax_ResponseFormat from "../Affjax.ResponseFormat/index.js";
import * as Affjax_Web from "../Affjax.Web/index.js";
import * as Control_Bind from "../Control.Bind/index.js";
import * as Control_Monad_Except_Trans from "../Control.Monad.Except.Trans/index.js";
import * as Data_Either from "../Data.Either/index.js";
import * as Data_HTTP_Method from "../Data.HTTP.Method/index.js";
import * as Data_Maybe from "../Data.Maybe/index.js";
import * as Data_OneOf from "../Data.OneOf/index.js";
import * as Data_Show from "../Data.Show/index.js";
import * as Effect_Aff from "../Effect.Aff/index.js";
import * as Effect_Aff_Class from "../Effect.Aff.Class/index.js";
import * as Effect_Class from "../Effect.Class/index.js";
import * as Foreign_Generic from "../Foreign.Generic/index.js";
import * as Foreign_Generic_Class from "../Foreign.Generic.Class/index.js";
import * as Network_JsonRPC from "../Network.JsonRPC/index.js";
import * as Network_RPC from "../Network.RPC/index.js";
import * as Restaumatic_I18nWrapper from "../Restaumatic.I18nWrapper/index.js";
import * as Restaumatic_Locales from "../Restaumatic.Locales/index.js";
import * as Restaumatic_Orders_RPC_Sites_Types from "../Restaumatic.Orders.RPC.Sites.Types/index.js";
import * as Restaumatic_Payments_Types_GetPaymentChannelsRequest from "../Restaumatic.Payments.Types.GetPaymentChannelsRequest/index.js";
import * as Restaumatic_Payments_Types_GetPaymentChannelsResponse from "../Restaumatic.Payments.Types.GetPaymentChannelsResponse/index.js";
import * as Restaumatic_PhoneNumbers_Types_ValidatePhoneNumberRequest from "../Restaumatic.PhoneNumbers.Types.ValidatePhoneNumberRequest/index.js";
import * as Restaumatic_Restaurants_RPC_Sites_Types from "../Restaumatic.Restaurants.RPC.Sites.Types/index.js";
import * as Restaumatic_Restaurants_Types_OrderingAvailability from "../Restaumatic.Restaurants.Types.OrderingAvailability/index.js";
import * as Type_Proxy from "../Type.Proxy/index.js";
var bind = /* #__PURE__ */ Control_Bind.bind(Effect_Aff.bindAff);
var liftEffect = /* #__PURE__ */ Effect_Class.liftEffect(Effect_Aff.monadEffectAff);
var show = /* #__PURE__ */ Data_Show.show(Restaumatic_Locales.showLocale);
var inj = /* #__PURE__ */ Data_OneOf.inj()({
    reflectSymbol: function () {
        return "NetworkError";
    }
});
var bind1 = /* #__PURE__ */ Control_Bind.bind(/* #__PURE__ */ Control_Monad_Except_Trans.bindExceptT(Effect_Aff.monadAff));
var liftEffect1 = /* #__PURE__ */ Effect_Class.liftEffect(/* #__PURE__ */ Control_Monad_Except_Trans.monadEffectExceptT(Effect_Aff.monadEffectAff));
var withExceptT = /* #__PURE__ */ Control_Monad_Except_Trans.withExceptT(Effect_Aff.functorAff);
var liftAff = /* #__PURE__ */ Effect_Aff_Class.liftAff(Effect_Aff_Class.monadAffAff);
var sitesRPC = function (dictEncode) {
    var runAffjax = Network_JsonRPC.runAffjax(dictEncode);
    return function (dictDecode) {
        var runAffjax1 = runAffjax(dictDecode);
        return function (dictRPCMethodName) {
            var rpc = Network_JsonRPC.rpc(dictRPCMethodName)(Effect_Aff.monadAff);
            var runAffjax2 = runAffjax1(dictRPCMethodName);
            return function (req) {
                return bind(liftEffect(Restaumatic_I18nWrapper.getGlobalLocale))(function (locale) {
                    return rpc(runAffjax2("/api/v1/sites/rpc")([ new Affjax_RequestHeader.RequestHeader("x-app-locale", show(locale)) ]))(req);
                });
            };
        };
    };
};
var rpcE = function () {
    return function (dictAPIUrl) {
        var apiUrl = Network_JsonRPC.apiUrl(dictAPIUrl);
        return function (dictEncode) {
            var encodeJSON = Foreign_Generic.encodeJSON(dictEncode);
            return function (dictEncodeWithOptions) {
                return function (dictDecode) {
                    var decodeJSONU = Network_JsonRPC.decodeJSONU(dictDecode);
                    return function (dictDecode1) {
                        var decodeErrorResponse = Network_RPC.decodeErrorResponse(dictDecode1);
                        return function (dictDecodeWithOptions) {
                            return function (dictRPCMethodName) {
                                var rpcMethodName = Network_JsonRPC.rpcMethodName(dictRPCMethodName);
                                return function (request) {
                                    var toOneOf = (function () {
                                        var $79 = inj(Type_Proxy["Proxy"].value);
                                        return function ($80) {
                                            return $79(Affjax.printError($80));
                                        };
                                    })();
                                    var request$prime = function (locale) {
                                        return {
                                            username: Affjax.defaultRequest.username,
                                            password: Affjax.defaultRequest.password,
                                            withCredentials: Affjax.defaultRequest.withCredentials,
                                            timeout: Affjax.defaultRequest.timeout,
                                            url: apiUrl(Type_Proxy["Proxy"].value) + ("/" + rpcMethodName(Type_Proxy["Proxy"].value)),
                                            headers: [ new Affjax_RequestHeader.RequestHeader("x-app-locale", show(locale)), new Affjax_RequestHeader.RequestHeader("Content-Type", "application/json") ],
                                            method: new Data_Either.Left(Data_HTTP_Method.POST.value),
                                            content: new Data_Maybe.Just(new Affjax_RequestBody["String"](encodeJSON(request))),
                                            responseFormat: Affjax_ResponseFormat.string
                                        };
                                    };
                                    var handleResponse = function (response) {
                                        if (response.status === 200) {
                                            return decodeJSONU(response.body);
                                        };
                                        return decodeErrorResponse(response.body);
                                    };
                                    return bind1(liftEffect1(Restaumatic_I18nWrapper.getGlobalLocale))(function (locale) {
                                        return bind1(withExceptT(toOneOf)(Affjax_Web.request(request$prime(locale))))(function (response) {
                                            return handleResponse(response);
                                        });
                                    });
                                };
                            };
                        };
                    };
                };
            };
        };
    };
};
var placeOrder = /* #__PURE__ */ (function () {
    var $81 = sitesRPC(Network_JsonRPC.encodeRequest(Restaumatic_Orders_RPC_Sites_Types.encodePlaceOrderRequest)(Foreign_Generic_Class.encodeWithOptionsOther(Restaumatic_Orders_RPC_Sites_Types.encodePlaceOrderRequest)))(Network_JsonRPC.decodeResponse(Restaumatic_Orders_RPC_Sites_Types.decodePlaceOrderResponse))(Restaumatic_Orders_RPC_Sites_Types.rPCMethodNamePlaceOrderRe);
    return function ($82) {
        return liftAff($81($82));
    };
})();
var getPaymentChannels = /* #__PURE__ */ (function () {
    var $83 = sitesRPC(Network_JsonRPC.encodeRequest(Restaumatic_Payments_Types_GetPaymentChannelsRequest.encodeGetPaymentChannelsRequest)(Foreign_Generic_Class.encodeWithOptionsOther(Restaumatic_Payments_Types_GetPaymentChannelsRequest.encodeGetPaymentChannelsRequest)))(Network_JsonRPC.decodeResponse(Restaumatic_Payments_Types_GetPaymentChannelsResponse.decodeGetPaymentChannelsResponse))(Restaumatic_Payments_Types_GetPaymentChannelsRequest.rPCMethodNameGetPaymentCh);
    return function ($84) {
        return liftAff($83($84));
    };
})();
var getOrderingAvailability = /* #__PURE__ */ (function () {
    var $85 = sitesRPC(Network_JsonRPC.encodeRequest(Restaumatic_Restaurants_RPC_Sites_Types.encodeGetOrderingAvailabilityRequest)(Foreign_Generic_Class.encodeWithOptionsOther(Restaumatic_Restaurants_RPC_Sites_Types.encodeGetOrderingAvailabilityRequest)))(Network_JsonRPC.decodeResponse(Restaumatic_Restaurants_Types_OrderingAvailability.decodeOrderingAvailability))(Restaumatic_Restaurants_RPC_Sites_Types.rPCMethodNameGetOrderingA);
    return function ($86) {
        return liftAff($85($86));
    };
})();
var getOrderSummary = /* #__PURE__ */ (function () {
    var $87 = sitesRPC(Network_JsonRPC.encodeRequest(Restaumatic_Orders_RPC_Sites_Types.encodeGetOrderSummaryRequest)(Foreign_Generic_Class.encodeWithOptionsOther(Restaumatic_Orders_RPC_Sites_Types.encodeGetOrderSummaryRequest)))(Network_JsonRPC.decodeResponse(Restaumatic_Orders_RPC_Sites_Types.decodeGetOrderSummaryResponse))(Restaumatic_Orders_RPC_Sites_Types.rPCMethodNameGetOrderSumm);
    return function ($88) {
        return liftAff($87($88));
    };
})();
var getCheckoutInfo = /* #__PURE__ */ (function () {
    var $89 = sitesRPC(Network_JsonRPC.encodeRequest(Restaumatic_Orders_RPC_Sites_Types.encodeGetCheckoutInfoRequest)(Foreign_Generic_Class.encodeWithOptionsOther(Restaumatic_Orders_RPC_Sites_Types.encodeGetCheckoutInfoRequest)))(Network_JsonRPC.decodeResponse(Restaumatic_Orders_RPC_Sites_Types.decodeCheckoutInfo))(Restaumatic_Orders_RPC_Sites_Types.rPCMethodNameGetCheckoutI);
    return function ($90) {
        return liftAff($89($90));
    };
})();
var checkPhone = /* #__PURE__ */ sitesRPC(/* #__PURE__ */ Network_JsonRPC.encodeRequest(Restaumatic_PhoneNumbers_Types_ValidatePhoneNumberRequest.encodeValidatePhoneNumberRequest)(/* #__PURE__ */ Foreign_Generic_Class.encodeWithOptionsOther(Restaumatic_PhoneNumbers_Types_ValidatePhoneNumberRequest.encodeValidatePhoneNumberRequest)))(/* #__PURE__ */ Network_JsonRPC.decodeResponse(Foreign_Generic_Class.booleanDecode))(Restaumatic_PhoneNumbers_Types_ValidatePhoneNumberRequest.rPCMethodNameValidatePhon);
export {
    checkPhone,
    getCheckoutInfo,
    getOrderSummary,
    getOrderingAvailability,
    getPaymentChannels,
    placeOrder,
    rpcE,
    sitesRPC
};
export {
    CheckoutInfo,
    FulfillmentTimeChoice,
    GetCheckoutInfoRequest,
    GetOrderSummaryRequest,
    GetOrderSummaryResponse,
    Cancelled,
    Completed,
    Placed,
    WaitingForConfirmation,
    WaitingForDispatch,
    WaitingForPayment,
    PlaceOrderRequest,
    ApplePayResponseToken,
    Errors,
    ExternalRedirect,
    PaymentForm,
    Redirect
} from "../Restaumatic.Orders.RPC.Sites.Types/index.js";
export {
    GetPaymentChannelsRequest
} from "../Restaumatic.Payments.Types.GetPaymentChannelsRequest/index.js";
export {
    GetPaymentChannelsResponse
} from "../Restaumatic.Payments.Types.GetPaymentChannelsResponse/index.js";
export {
    ValidatePhoneNumberRequest
} from "../Restaumatic.PhoneNumbers.Types.ValidatePhoneNumberRequest/index.js";
